import * as tslib_1 from "tslib";
import { BaseBetsApiClient } from './BaseBetsApiClient';
export var BETS_ENDPOINTS = {
    PLACE_BETS: "/placeBets",
    CALCULATE_BETS: "/calculateBets",
    PRECALCULATE_BETS: "/precalculate"
};
var BetsApiClient = /** @class */ (function (_super) {
    tslib_1.__extends(BetsApiClient, _super);
    function BetsApiClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BetsApiClient.prototype.placeBets = function (request) {
        var fetchOptions = {
            request: request
        };
        return _super.prototype.executeRequest.call(this, BETS_ENDPOINTS.PLACE_BETS, fetchOptions);
    };
    BetsApiClient.prototype.calculateBets = function (request) {
        var fetchOptions = {
            request: request
        };
        return _super.prototype.executeRequest.call(this, BETS_ENDPOINTS.CALCULATE_BETS, fetchOptions);
    };
    BetsApiClient.prototype.precalculateBets = function (request) {
        var fetchOptions = {
            request: request
        };
        return _super.prototype.executeRequest.call(this, BETS_ENDPOINTS.PRECALCULATE_BETS, fetchOptions);
    };
    return BetsApiClient;
}(BaseBetsApiClient));
export { BetsApiClient };
//# sourceMappingURL=BetsApiClient.js.map